import { Box } from '@rebass/grid'
import * as React from 'react'
import { Text } from 'src/elements'
import styled from 'styled-components'

const Container = styled(Box)`
  border-radius: 10px;
  padding: 16px;
  background-color: #f7f8f8;
  word-break: break-all;
`

const DisplayBlock = ({ text }) => (
  <Container>
    <Text.Content
      dangerouslySetInnerHTML={{
        __html: text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      }}
    />
  </Container>
)
export default DisplayBlock



// WEBPACK FOOTER //
// ./src/components/Reply/DisplayBlock.tsx